import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import TabsLayout from "../../layout/TabsLayout/TabsLayout";
import styles from "./ProductShot.module.scss";

const ProductShot = () => {
	const { t } = useTranslation("translation", { keyPrefix: "productShot" });

	return (
		<TabsLayout contentClassName={styles.content} title={t("header")} subTabs={[]}>
			<Outlet />
		</TabsLayout>
	);
};

export default observer(ProductShot);
